const KEY = 'uoidle.avisos';

let mostrarNaTela = true;

function ler() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return;
    const parsed = JSON.parse(raw) as { mostrarNaTela?: unknown };
    if (typeof parsed.mostrarNaTela === 'boolean') mostrarNaTela = parsed.mostrarNaTela;
  } catch {
    /* storage cheio ou JSON ruim — fica o default */
  }
}

ler();

function persistir() {
  try {
    localStorage.setItem(KEY, JSON.stringify({ mostrarNaTela }));
  } catch {
    /* ignore */
  }
}

export function mostrarAvisosNaTela(): boolean {
  return mostrarNaTela;
}

export function aplicarAvisos(patch: { mostrarNaTela?: boolean }) {
  if (patch.mostrarNaTela !== undefined) mostrarNaTela = patch.mostrarNaTela;
  persistir();
}

export function snapshotAvisos() {
  return { mostrarNaTela };
}
